<script lang="ts">
	export let as: 'a' | 'button' = 'button';
	let className: string = "";
	export { className as class };

</script>

<svelte:element
	this={as}
	class="bg-neutral-50 h5 font-medium inline-flex align-items font-sans text-primary rounded-md px-5 py-2 text-center hover:bg-primary hover:text-neutral-100 transition-colors  focus-visible:ring-offset-3 focus-visible:ring-3 focus-visible:ring-primary outline-none focus-visible:bg-primary focus-visible:ring-offset-neutral-100 focus-visible:text-neutral-100 {className}"
	{...$$restProps}
	on:click
>
	<slot />
</svelte:element>
